import { createRouter, createWebHistory } from "vue-router";
import ServiceView from "@/view/ServiceView.vue";
import HomePage from "@/view/HomePage.vue";
import AboutUs from "@/view/AboutUs.vue";
import ContactUs from "@/view/ContactUs.vue";
import ComputerAndAccessories from "@/view/SubService/ComputerAndAccessories.vue";
import CompanyEvents from "@/view/CompanyEvents.vue";
import PackageISPView from "@/view/SubService/PackageISPView.vue";
import AllServicesView from "@/view/AllServicesView.vue";
import DataCenter from "@/view/SubService/DataCenter.vue";
import ITServices from "@/view/SubService/ITServices.vue";
import SoftwareSolution from "@/view/SubService/SoftwareSolution.vue";
import CompanyCareer from "@/view/CompanyCareer.vue";
import ApplyForm from "@/components/CareerComponent/applyForm.vue";
import eventShow from "@/components/Events/eventShow.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: HomePage,
  },
  {
    path: "/form",
    name: "Form",
    component: ApplyForm,
  },
  {
    path: "/services",
    name: "Services",
    component: ServiceView,
    children: [
      {
        path: "",
        name: "All Services",
        component: AllServicesView,
      },
      {
        path: "data-center",
        name: "Data Center",
        component: DataCenter,
      },
      {
        path: "computer-and-accessories",
        name: "Accessories",
        component: ComputerAndAccessories,
      },
      {
        path: "internet-service-provider",
        name: "Internet Service Provider",
        component: PackageISPView,
      },
      {
        path: "it-services",
        name: "IT Services",
        component: ITServices,
      },
      {
        path: "software-solutions",
        name: "Software Solutions",
        component: SoftwareSolution,
      },
    ],
  },
  {
    path: "/about-us",
    name: "About Us",
    component: AboutUs,
  },
  {
    path: "/contact-us",
    name: "Contact Us",
    component: ContactUs,
  },
  {
    path: "/events",
    name: "Events",
    component: CompanyEvents,
  },
  {
    path: "/events/:id",
    name: "EventsDetail",
    component: eventShow,
    props: true,
  },
  {
    path: "/careers",
    name: "Careers",
    component: CompanyCareer,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  // Scroll behavior
  scrollBehavior(to, from, savedPosition) {
    // If there's a saved position (e.g., user navigates back), use it
    if (savedPosition) {
      return savedPosition;
    } else {
      // Otherwise, scroll to the top
      return { top: 0, left: 0 };
    }
  },
});

export default router;
